export class State {}

const state = new State();

export default state;
